import { HttpClient } from "../../rest/utils/http";

export const AddCompanyInfo = async (data: any) => {
  return await HttpClient.post(`/api/atab/member-company/member/company`, data);
};
